import React from "react";

export const AgentKnowledgeContentHeader: React.FC<{
  icon: React.ReactNode;
  title: string;
  description?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
}> = ({ icon, title, description, endContent, startContent }) => {
  return (
    <div className="border-dark-100 flex h-[81px] shrink-0 items-start justify-between gap-3 border-0 border-b border-solid px-10 pt-8">
      <div className="flex items-center gap-3 overflow-hidden">
        {startContent}
        <div className="flex shrink-0 items-center justify-center">{icon}</div>
        <div className="flex items-baseline gap-2 overflow-hidden">
          <span className="font-secondary shrink-0 truncate text-lg font-medium text-black">
            {title}
          </span>
          {description && (
            <span className="text-dark-700 font-secondary truncate text-sm">
              {description}
            </span>
          )}
        </div>
      </div>
      {endContent}
    </div>
  );
};
